export default class SessionLocation {
  sessionLocationId?: number | null;
  name?: string | null;

  public constructor(params: SessionLocation = {} as SessionLocation) {
    let { sessionLocationId = 0, name = "" } = params;
    (this.sessionLocationId = sessionLocationId), (this.name = name);
  }
}
